var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import { createComponent } from '@cloudflare/style-container';

var styles = function styles(_ref) {
  var theme = _ref.theme,
      loading = _ref.loading;
  return {
    zIndex: theme.zIndex,
    width: theme.width,
    height: theme.height,
    margin: theme.margin,
    padding: theme.padding,
    borderBottom: theme.borderBottom,
    borderTop: theme.borderTop,
    borderLeft: theme.borderLeft,
    borderRight: theme.borderRight,
    borderRadius: theme.borderRadius,
    flex: theme.flex,

    verticalAlign: theme.verticalAlign,
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize,
    opacity: loading ? 0.5 : 1,
    background: theme.background,
    color: theme.color,
    outline: theme.outline,

    transition: theme.transition,
    textIndent: theme.textIndent,

    '&:hover': {
      borderColor: theme['&:hover'].borderColor
    },
    '&:focus': {
      borderColor: theme['&:hover'].borderColor,
      outline: theme['&:hover'].outline
    },
    '&:disabled': {
      background: theme.background,
      color: theme.color
    }
  };
};

var Input = function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  _createClass(Input, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          inputRef = _props.inputRef,
          loading = _props.loading,
          testId = _props.testId,
          restProps = _objectWithoutProperties(_props, ['inputRef', 'loading', 'testId']);

      return React.createElement('input', _extends({ 'data-test-id': testId }, restProps, { ref: inputRef }));
    }
  }]);

  return Input;
}(React.Component);

Input.propTypes = {
  type: PropTypes.oneOf(['text', 'email', 'number', 'password', 'search', 'color']),
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  inputRef: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  testId: PropTypes.string
};

Input.defaultProps = {
  type: 'text'
};
Input.displayName = 'Input';

export default createComponent(styles, Input);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-input/es/Input.js
// module id = 637
// module chunks = 1